var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main",class:_vm.$style.main},[_c('vue-headful',{attrs:{"title":"Pending Editor"}}),_c('div',{class:_vm.$style.titleContainer},[_vm._v("Pending Editor  ")]),_c('StagingEditorContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }